import { Component, Inject, Optional } from '@angular/core';
import { SETTINGS_CONFIG_DATA } from '../../controller-selector.component';

@Component({
    selector: 'number-settings',
    templateUrl: './number-settings.component.html',
    styleUrls: ['./number-settings.component.scss'],
    standalone: false
})
export class NumberSettingsComponent {
    constructor(
        @Optional() @Inject(SETTINGS_CONFIG_DATA) public data: { controllerName: string, arguments: any }
    ) { }
}
